module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "content"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    attrs: {
      "id": "main-colum"
    }
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.picks), function(p) {
    return _c('pick', {
      key: p.id,
      attrs: {
        "pick": p
      }
    })
  }), _vm._v(" "), (_vm.picks && _vm.picks.length === 0) ? _c('div', [_c('p', [_vm._v("\n          There are no picks currently posted. To receive picks immediately\n          when they are posted, please set up pick notifications in the\n          "), _c('router-link', {
    attrs: {
      "to": {
        path: '/myaccount'
      }
    }
  }, [_vm._v("\n            my account section (premium members only).\n          ")])], 1), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('adsense', {
    attrs: {
      "ad-client": "ca-pub-8213113866781504",
      "ad-slot": "7567805932",
      "ad-layout-key": "-71-1m-75+i4+5r",
      "ad-format": "fluid"
    }
  })], 2), _vm._v(" "), _c('sidebar', {
    attrs: {
      "testimonial": _vm.testimonial
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://affiliates.betanysports.eu/tracking/Affiliate.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18",
      "target": "_top"
    }
  }, [_c('img', {
    attrs: {
      "src": "https://affiliates.betanysports.eu/tracking/banner.aspx?idBook=3&mediaTypeID=11777&AffUrlID=1606&LandingPageID=18",
      "hspace": "0",
      "vspace": "0",
      "border": "0",
      "alt": "Bet at Betanysports.eu"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Get the lowest juice at BetOnline,\n          "), _c('a', {
    attrs: {
      "href": "https://record.commission.bz/_k86Ic18Yvp1qkvbhkiKqDGNd7ZgqdRLk/1/",
      "target": "_blank"
    }
  }, [_vm._v("sign up here and receive a 50% bonus!")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14dedf48!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/FreePicks.vue
// module id = 483
// module chunks = 1